module.exports = __webpack_public_path__ + "static/monei_qr-5daa9d426af640531f1b8b3930d89ee9.svg";